export default "__VITE_ASSET__Bvcf8VjE__"